export let ToApiDate = function (tz, dt) {
    let year = dt.getFullYear();
    let m = dt.getMonth() + 1;
    let month = m > 9 ? m : '0' + m;
    let date = dt.getDate() > 9 ? dt.getDate() : '0' + dt.getDate();
    return year + '-' + month + '-' + date;
}